



















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { EditorFileStore } from "./FileStoreEditModal.vue";
import { required, maxLength, minLength } from "vuelidate/lib/validators";

@Component({
	mixins: [validationMixin],
	model: {
		prop: "fileStore",
		event: "input"
	},
	validations: {
		path: {
			required,
			minLength: minLength(1),
			maxLength: maxLength(260)
		}
	}
})
export default class WindowsConfiguration extends Vue {
	@Prop({ type: Object, default: null })
	private fileStore: EditorFileStore;

	private path: string = "";

	/**
	 * Watcher which fires when the filestore changes in the parent. Ensures the path we're editing is kept
	 * up-to-date with the path in the fileStore prop.
	 */
	@Watch("fileStore", { immediate: true })
	private onFileStoreChanged(newFilestore: EditorFileStore) {
		this.path = newFilestore.path;
	}

	/**
	 * Watcher which fires when our validation state changes. Emits a validate event, along with a value
	 * indicating whether the filestore is valid or not.
	 */
	@Watch("$v.$invalid", { immediate: true })
	private onValidationStateChanged(invalid: boolean) {
		this.$emit("validate", !invalid);
	}

	/**
	 * Handler for when our filestore path is changed by the user. Ensures the data is valid, before emitting an
	 * input event.
	 */
	private onConfigurationChanged() {
		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}

		const updatedFileStore: EditorFileStore = {
			...this.fileStore,
			path: this.path
		};

		this.$emit("input", updatedFileStore);
	}
}
